import { useMutation } from "@tanstack/react-query";
import {
  formChatRepository,
} from "../repositories/formChat.repository";
import type { FormChatMessageRequest } from "../repositories/formChat.repository";

export const formChatMutationKey = ["form-chat", "message"];

export function useFormChatMutation() {
  return useMutation({
    mutationKey: formChatMutationKey,
    mutationFn: ({
      terreiroId,
      payload,
    }: {
      terreiroId: string;
      payload: FormChatMessageRequest;
    }) => formChatRepository.sendMessage(terreiroId, payload),
  });
}
